import type {
  ConnectActivityConfig,
  ConnectActivityLevelResult,
  ConnectActivityMentorAnswer,
  ConnectActivityResult,
} from "@/lib/api/activities";

type ConnectLevelIndex = 0 | 1 | 2;

export function getConnectMentorAnswer(
  config: ConnectActivityConfig | null | undefined,
  level: ConnectLevelIndex,
): ConnectActivityMentorAnswer | undefined {
  return config?.mentor_answers[level] ?? undefined;
}

export function getConnectLevelResult(
  result: ConnectActivityResult | null | undefined,
  level: ConnectLevelIndex,
): ConnectActivityLevelResult | null {
  return result?.levels[level] ?? null;
}

export function countCompletedConnectLevels(
  result: ConnectActivityResult | null | undefined,
): number {
  return result?.levels.filter((level) => level !== null).length ?? 0;
}
